import React from 'react'

import Container from 'components/Container'
import { Navigation } from 'components/Navigation'
import { BrowserRouter } from 'react-router-dom'
import { getRoutesByAppName } from 'utils/helper'

// eslint-disable-next-line import/order
import { NavigationProvider } from './Context'

import './tailwind.css'
import { useListenTranslate } from './hooks/translate'

interface Props {
  appName?: string
}

const Root: React.FC<Props> = ({ appName }) => {
  useListenTranslate()

  return (
    <NavigationProvider routes={getRoutesByAppName(appName)}>
      <BrowserRouter>
        <Container>
          <Navigation />
        </Container>
      </BrowserRouter>
    </NavigationProvider>
  )
}

export default Root
